import { render, staticRenderFns } from "./MaingroupAndGroupTabs.vue?vue&type=template&id=744fcda0"
import script from "./MaingroupAndGroupTabs.vue?vue&type=script&lang=js"
export * from "./MaingroupAndGroupTabs.vue?vue&type=script&lang=js"
import style0 from "./MaingroupAndGroupTabs.vue?vue&type=style&index=0&id=744fcda0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports